<template>
  <popper
    ref="popper"
    trigger="hover"
    append-to-body
    :options="{
      placement,
      modifiers
    }"
    enter-active-class="opacity-animate-enter-active"
    leave-active-class="opacity-animate-leave-active"
    transition="opacity-animate"
  >
    <div
      class="sj-tooltips"
      :class="[`sj-tooltips-${size}`, `sj-tooltips-${theme}`]"
    >
      <slot name="tooltips">Popper Content</slot>
    </div>

    <slot slot="reference" name="reference">
      Reference Element
    </slot>
  </popper>
</template>

<script>
/**
 * tooltip相当于功能单一的dropdown，仅用于显示少量文本，功能与选项较少
 */
import popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";

export default {
  name: "SjTooltip",
  components: {
    popper
  },
  data() {
    return {
      modifiers: {
        computeStyle: {
          gpuAcceleration: false
        },
        preventOverflow: {
          enabled: false
        },
        hide: {
          enabled: false
        },
        arrow: {
          enabled: true,
          fn: (data, options) => {
            data.arrowElement = data.instance.popper.querySelector(
              options.element
            );
            data.offsets.arrow = { left: "", top: "" };
            switch (data.placement) {
              case "top-start":
              case "bottom-start":
                data.offsets.arrow.left = 20;
                break;
              case "top":
              case "bottom":
                data.offsets.arrow.left = data.popper.width / 2 - 6;
                break;
              case "top-end":
              case "bottom-end":
                data.offsets.arrow.left = data.popper.width - 20 - 12;
                break;
              case "left-start":
              case "right-start":
                data.offsets.arrow.top = 10;
                break;
              case "left":
              case "right":
                data.offsets.arrow.top = data.popper.height / 2 - 6;
                break;
              case "left-end":
              case "right-end":
                data.offsets.arrow.top = data.popper.height - 10 - 12;
                break;
              default:
                break;
            }
            return data;
          }
        }
      }
    };
  },
  props: {
    placement: {
      type: String,
      required: true
      // }
    },
    size: {
      type: String,
      default: "small",
      validator(v) {
        return ["auto", "large", "small", "small-auto"].indexOf(v) !== -1;
      }
    },
    theme: {
      default: "dark",
      type: String,
      validator(v) {
        return ["dark", "light"].indexOf(v) !== -1;
      }
    }
  }
};
</script>

<style>
.opacity-animate-enter-active,
.opacity-animate-leave-active {
  /*transition: opacity 0.15s;*/
}

.opacity-animate-enter,
.opacity-animate-leave-to {
  /*opacity: 0;*/
}
</style>

<style lang="less" scoped>
@--tooltips-arrow-size: 6px;

.sj-tooltips-dark {
  --tooltips-background-color: @color-dark;
  --tooltips-color: @color-antibg;
}

.sj-tooltips-light {
  --tooltips-background-color: @color-gray-3;
  --tooltips-color: @color-dark;
}

.sj-tooltips {
  position: absolute;
  display: inline-block;
  width: auto;
  text-align: center;
  border-radius: 4px;
  box-sizing: border-box;
  background-color: var(--tooltips-background-color);
  color: var(--tooltips-color);
  z-index: 999999;
  word-wrap: break-word;
}

.sj-tooltips-large {
  max-width: 180px;
  padding: 10px 20px;
  .text("body");
}

.sj-tooltips-auto {
  .text("caption");
}

.sj-tooltips-small {
  max-width: 116px;
  padding: 5px 10px;
  .text("caption");
}
.sj-tooltips-small-auto {
  padding: 5px 10px;
  .text("caption");
}

.sj-tooltips {
  /deep/ .popper__arrow {
    border-bottom-width: 0;
    border-top-color: var(--tooltips-background-color);
    position: absolute;
    display: block;
    width: 0;
    height: 0;
    border-width: @--tooltips-arrow-size;
    border-color: transparent;
    border-style: solid;
    filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.1));
  }
}

.sj-tooltips[x-placement^="top"] {
  margin-bottom: 6px;
  /deep/ .popper__arrow {
    bottom: calc(@--tooltips-arrow-size * -1);
    border-bottom-width: 0;
    border-top-color: var(--tooltips-background-color);
  }
}

.sj-tooltips[x-placement^="bottom"] {
  margin-top: 6px;
  /deep/ .popper__arrow {
    top: calc(@--tooltips-arrow-size * -1);
    border-top-width: 0;
    border-bottom-color: var(--tooltips-background-color);
  }
}

.sj-tooltips[x-placement^="right"] {
  margin-left: 6px;
  /deep/ .popper__arrow {
    left: calc(@--tooltips-arrow-size * -1);
    border-left-width: 0;
    border-right-color: var(--tooltips-background-color);
  }
}

.sj-tooltips[x-placement^="left"] {
  margin-right: 6px;
  /deep/ .popper__arrow {
    right: calc(@--tooltips-arrow-size * -1);
    border-right-width: 0;
    border-left-color: var(--tooltips-background-color);
  }
}
</style>
